import gql from "graphql-tag";
import { entityCommentFragment } from "@/graphql/comments/fragments";

export const GET_ENTITY_COMMENTS = gql`
  query GetEntityComments($entityType: CommentEntityType!, $entityId: ID!) {
    entityComments(entityType: $entityType, entityId: $entityId) {
      ...EntityCommentFragment
    }
  }
  ${entityCommentFragment}
`;
